const storyOneLink = 'https://proracun.bjelovar.hr/proracun';
const storyOneName = 'Kako se gradski proračun puni i troši';
const storyThreeLink = 'https://proracun.bjelovar.hr/proracunski-proces';
const storyThreeName = 'Detaljan prikaz proračunskog procesa';

export const glossaryTerms: GlossaryItem[] = [
    {
        id: 0,
        word: 'Decentralizirana funkcija',
        description: 'Dio javnih usluga država prenosi na lokalnu razinu. Primjerice, županije dobiju nadležnost nad srednjim školama i bolnicama, dok gradovi dobiju vrtiće, osnovne škole i vatrogasce. Zbog toga država izdvaja dio sredstava kako bi pomogla gradovima i općinama da uspješno financiraju navedene javne usluge. Zbog toga svi gradovi i općine dobivaju jedan dio novca iz državnog proračuna, što ide pod kategoriju pomoći iz proračuna',
        relatedLinks: [
            {
                text: 'pomoći iz proračuna',
                link: '#19'
            }
        ]
    },
    {
        id: 1,
        word: 'Deficit (proračuna)',
        description: 'Višak rashoda nad prihodima u određenom proračunskom razdoblju. Deficit proračuna može biti primarni (kada su rashodi tekućeg poslovanja grada ili općine veći od tekućih prihoda), a može biti i ukupni (grad ulazi u deficit zbog otplate starih dugova, odnosno visokih kamata na iste). U pravilu je zabrinjavajuće ako lokalne jedinice (ali i država) ostvaruju primarni deficit dugi niz godina. To znači da je tekuće poslovanje lokalne jedinice neodrživo. Normalno je da primjerice grad ostvaruje primarni suficit no tek nakon otplate starih kredita ulazi u deficit (koji se onda opet financira novim zaduživanjem).',
        relatedLinks: [
            {
                text: 'primarni suficit ili deficit',
                link: '#22'
            }
        ],
    },
    {
        id: 2,
        word: 'Dug',
        description: 'Posljedica akumuliranih deficita proračuna; iz godine u godinu visoki proračunski deficiti se moraju financirati novim zaduženjima, odnosno dizanjem novih kredita, zajmova ili izdavanjem obveznica od strane gradske vlasti. Dug može biti kratkoročni (dospijeće unutar godine dana) ili dugoročni (dospijeće iznad godine dana). Kao i svaki kredit može biti namjenski i nenamjenski, u stranoj ili domaćoj valuti, te sa fiksnom ili varijabilnom kamatnom stopom.'
    },
    {
        id: 3,
        word: 'Ekonomska klasifikacija proračuna',
        description: 'Prikaz prihoda i rashoda proračuna prema njihovoj ekonomskoj namjeni (npr. porezi, komunalni doprinosi, plaće zaposlenima, materijalni troškovi, itd.)',
        relatedStories: [
            {
                text: storyOneName,
                link: storyOneLink
            }
        ]
    },
    {
        id: 4,
        word: 'Financijska imovina',
        description: 'Dio proračuna koji obuhvaća svu nematerijalnu imovinu koja je vezana uz financijsko tržište. Konkretno to su novac, depoziti, obveznice, zajmovi, i sl.'
    },
    {
        id: 5,
        word: 'Fiskalna (proračunska) godina',
        description: 'U Hrvatskoj je fiskalna godina jednaka kalendarskoj godini te traje od 01.01. do 31.12. svake godine.'
    },
    {
        id: 6,
        word: 'Fiskalno izravnavanje',
        description: 'Gradovi i općine dobivaju pomoći iz središnjeg proračuna ako su siromašniji od prosjeka odnosno ne ostvaruju dovoljnu ekonomsku aktivnost. U pravilu se radi o područjima posebne državne skrbi (ratno stradala, brdsko-planinska područja, ili otoci) čime se ispravljaju lokalne nejednakosti.',
        relatedLinks: [
            {
                text: 'pomoći iz proračuna',
                link: '#19'
            }
        ]
    },
    {
        id: 7,
        word: "Funkcijska klasifikacija proračuna",
        description: 'Prikaz rashoda proračuna prema njihovoj funkciji (npr. javni red i sigurnost, obrazovanje, socijalna zaštita, zaštita okoliša, rekreacija, kultura, itd.)',
        relatedStories: [
            {
                text: storyOneName,
                link: storyOneLink
            }
        ]
    },
    {
        id: 8,
        word: 'Gradonačelnik/ca',
        description: 'Najviša izvršna funkcija gradske vlasti. Gradonačelnika grada (odnosno načelnika općine) biraju građani neposredno na izborima svake 4 godine. Gradonačelnik predlaže svoj proračun gradskom vijeću, te kroz njega vrši svoje ekonomske politike i održava izborna obećanja.',
    },
    {
        id: 9,
        word: 'Gradski ured za financije',
        description: 'Sastavlja, planira, priprema i izvršava gradski proračun. Osim toga, gradski ured prati i naplatu prihoda, rast rashoda, vrši proces zaduživanja i otplate dugova, te izrađuje sve financijske izvještaje. Gradski ured za financije je operativni izvršitelj proračuna.',
    },
    {
        id: 10,
        word: 'Gradski proračunski korisnici',
         description: "Sve institucije koje je osnovao grad, odnosno koje su u gradskom vlasništvu, te se financiraju iz gradskog proračuna. Primjerice, vrtići, osnovne škole, muzeji, kazališta, knjižnice, sportski objekti, itd. Grad im isplaćuje plaće i plaća sve materijalne troškove. Oni su sudionici proračunskog procesa jer donose gradskom uredu za financije planove rashoda za iduću godinu.",
     },
    {
        id: 11,
        word: "Gradsko vijeće",
        description: "Najviše zakonodavno tijelo grada. Ono donosi odnosno izglasava proračun. Kroz raspravu o proračunu vijeće analizira sve planirane prihode i rashode, kao i sve programe i politike koje gradonačelnik planira financirati u idućoj godini. Proračun je službeno na snazi tek nakon što ga potvrdi (izglasa) gradsko vijeće. Osim toga vijeće mora odobriti i svako zaduženje grada.",
    },
    {
        id: 12,
        word: "Jedinice lokalne i područne (regionalne) samouprave",
        description: "Obuhvaćaju 556 općina i gradova te 21 županiju u Republici Hrvatskoj.",
    },
    {
        id: 13,
        word: "Komunalna naknada",
        description: "Plaćaju svi korisnici nekog stambenog, poslovnog, garažnog prostora, te građevinskog zemljišta. Iz naknade se financiraju komunalne djelatnosti: čišćenje javnih površina, odvodnja voda, odvoz smeća, i održavanje javne infrastrukture (rasvjeta, javne površine, groblja, nerazvrstane ceste).",
    },
    {
        id: 14,
        word: "Komunalni doprinos",
        description: "Plaća vlasnik građevinske čestice na kojoj se nešto gradi. Iz doprinosa se financira građenje i korištenje javnih površina, javne rasvjete, nerazvrstanih cesta i groblja.",
    },
    {
        id: 15,
        word: "Konsolidirani proračun",
        description: "Jedinstveni proračun za sve proračunske i izvanproračunske korisnike. Primjerice konsolidirani proračun Republike Hrvatske će osim središnjeg državnog proračuna obuhvatiti u istom financijskom izvještaju sve izvanproračunske korisnike (HZZO, HZMO, HZZ, Hrvatske vode, Hrvatske ceste, itd.), te sve jedinice lokalne samouprave (sve županije, gradove, i općine).",
    },
    {
        id: 16,
        word: "Materijalni rashod",
        description: "Sva dobra i usluge koje grad kupuje na tržištu a koje su potrebne za nesmetano poslovanje grada. Tu spadaju rashodi za struju, telefon, poštu, uredski materijal, usluge tekućeg održavanja, komunalne usluge, usluge promidžbe i informiranja, intelektualne usluge, računalne usluge, trošak reprezentacije (službeni ručkovi i pokloni), službena putovanja, razne naknade zaposlenicima, te čak i naknade članovima u gradskom vijeću. Za većinu ovih dobara grad raspisuje javne natječaje i traži najbolju ponudu.",
    },
    {
        id: 17,
        word: "Nefinancijska imovina",
        description: "Uključuje stambene i poslovne objekte, škole, vrtiće, ceste i željezničku infrastrukturu, uređaji i strojevi, uredska oprema, umjetnička djela i knjige, sportska oprema, automobili. Neto izdaci za nefinancijsku imovinu su posebna kategorija proračuna koja bilježi financiranje za kupovinu svih navedenih dobara.",
    },
    {
        id: 18,
        word: "Neto financiranje",
        description: 'Razlika primitaka i izdataka za financijsku imovinu u proračunu. Neto financiranje mora biti jednako višku/manjku iz tekućih proračunskih prihoda i rashoda, odnosno mora biti jednako neto zaduživanju države.',
        relatedLinks: [
            {
                text: 'račun financiranja',
                link: '#27'
            }
        ]
    },
    {
        id: 19,
        word: "Pomoći iz središnjeg državnog proračuna",
        description: 'Svi gradovi i općine dobivaju pomoći iz središnjeg državnog proračuna ili od županija (a ponekad i od drugih gradova). One čine u prosjeku između 1/3 i 1/5 ukupnih prihoda gradova i općina i treća su po važnosti stavka lokalnih proračuna. Gradovi i općine dobivaju pomoći iz središnjeg proračuna ako su siromašniji od prosjeka odnosno ne ostvaruju dovoljnu ekonomsku aktivnost (tzv. fiskalno izravnavanje koje većinom ide područjima posebne državne skrbi čime se ispravljaju lokalne nejednakosti), kao naknade štete zbog elementarnih nepogoda (poplave, požari, suše), ili kao zamjena za prihode od poreza na dobit. Neke lokalne jedinice ne mogu samostalno financirati određene javne usluge (školstvo, vatrogasci, socijalna skrb) i zbog toga im država omogućava dodatne izvore financiranja (država ostvaruje decentraliziranu funkciju).',
        relatedLinks: [
            {
                text: 'decentralizirana funkcija',
                link: '#0'
            },
            {
                text: 'fiskalno izravnavanje',
                link: '#6'
            },
        ]
    },
    {
        id: 20,
        word: "Porez",
        description: "U klasičnoj ekonomskoj definiciji porez je „prisilno davanje državi bez direktne protučinidbe i unaprijed utvrđene namjene“. Porezi su glavni način putem kojega država ubire prihode radi financiranja svoje djelatnosti i javnih dobara i usluga koje pruža građanima.",
    },
    {
        id: 21,
        word: "Prihodi proračuna",
        description: "Sav prihod koji se ostvaruje od tekućih (redovnih) aktivnosti grada ili općine. Uključuju prihode od poreza (porez i prirez na dohodak, porez na imovinu, itd.), pomoći iz središnjeg državnog proračuna, komunalni doprinosi i naknade, prihodi od prodaje imovine i ostali prihodi (od imovine, pristojbi, kazni, po posebnim propisima).",
    },
    {
        id: 22,
        word: "Primarni suficit ili deficit",
        description: "Razlika između prihoda i rashoda tekućeg poslovanja grada ili općine, kada nisu uključeni izdaci za kamate. Poslovanje lokalne jedinice je održivo ako u pravilu ostvaruje primarni suficit. Ako dugi niz godina zaredom ostvaruje primarni deficit to je glavni pokazatelj da je poslovanje lokalne jedince neodrživo. Tada su potrebne reforme lokalnih financija.",
    },
    {
        id: 23,
        word: "Prirez",
        description: "Porez koji se obračunava povrh poreza na dohodak, a kojega imaju pravo nametati samo gradovi i općine gdje je građanin prijavljen da živi. Porez na dohodak je osnovica prireza (npr. porez na dohodak na nečiju neto plaću od 6500kn iznosi ukupno 886n mjesečno, što znači da će se prirez od npr. 12% obračunati na tih 886kn, a ne na čitavu plaću. Trošak prireza će biti 102kn, a ukupni trošak poreza i prireza koje će građanin uplatiti u proračun će biti 992kn).",
    },
    {
        id: 24,
        word: "Projekcija",
        description: "Proračun se planira za iduću godinu (u 2018. za 2019.) dok se projekcije donose za iduće dvije godine (2020. i 2021.)",
    },
    {
        id: 25,
        word: "Proračun",
        description: "Plan i prikaz prihoda i rashoda za određeno vremensko razdoblje, ili jednostavno rečeno, prikaz na što sve neki grad troši novce od građana, i kako ih dobiva od građana.",
    },
    {
        id: 26,
        word: "Proračunski proces",
        description: 'Svaki proračun rezultat je dugog procesa pripreme i planiranja. Prvo ga se sastavlja, potom ga se usvaja, te zatim izvršava i kontrolira. To su ujedno i tri glavne faze donošenja proračuna jednog grada li općine u Hrvatskoj. Od pripreme plana proračuna do njegova izvršenja i kontrole može trajati do dvije i pol godine. Pripreme kreću od drugog kvartala aktualne godine (primjerice 2018.), da bi se proračun izglasalo do kraja aktualne godine za iduću godinu (2019.), tokom 2019. se proračun izvršava, a do kraja prvog kvartala 2020. se sastavlja izvještaj o izvršenju proračuna nakon čega slijedi nadzor i revizija.',
        relatedStories: [
            {
                text: storyThreeName,
                link: storyThreeLink,
            }
        ]
    },
    {
        id: 27,
        word: "Račun financiranja",
        description: "Sve financijske transakcije koje služe za uzimanje novih kredita ili otplate starijih bilježe se na računu financiranja. Gradovi i općine, za razliku od središnje države nemaju previše opcija, te se uglavnom zadužuju putem kredita kod poslovnih banaka ili HBOR-a. Relativno malo gradova koristi opciju prodaje obveznica i drugih vrijednosnih papira na domaćem ili stranom tržištu. Kada grad uzima kredit to također radi putem javnog natječaja, a kao jamca navodi središnju državu.",
    },
    {
        id: 28,
        word: "Rashodi proračuna",
        description: "Sva potrošnja koju grad ili općina imaju u proračunskom razdoblju. Obuhvaća troškove za zaposlene (plaće i doprinosi), materijalne rashode, donacije i pomoći, izdatke za nefinancijsku imovinu, i ostalo (naknade kućanstvima, subvencije, financijski rashodi).",
    },
    {
        id: 29,
        word: "Rebalans",
        description: "Usklađenje plana sa izvršenjem. Plan i izvršenje gotovo se uvijek razlikuju zbog čitavog niza faktora koji mogu utjecati i na prihode i na rashode. Prihodi mogu rasti zbog boljeg prikupljanja poreza od očekivanog ili zbog priljeva neočekivanih EU sredstava. S druge strane prihodi mogu i padati zbog slabijeg prikupljanja poreza, dok rashodi mogu rasti zbog neočekivanih događaja poput elementarnih nepogoda. Zbog toga se tokom godine često rade rebalansi proračuna, kako bi se ili oslobodila nova sredstva za proračunske korisnike ili građane, ili kako bi se zatražio kredit za financiranje neočekivanih troškova.",
    },
    {
        id: 30,
        word: "Suficit",
        description: "Višak prihoda nad rashodima u određenom proračunskom razdoblju. Primarni suficit je višak tekućih prihoda nad tekućim rashodima. U pravilu dobro je kada grad ostvaruje primarne suficite.",
    },
    {
        id: 31,
        word: "Tekuće donacije i kapitalne pomoći",
        description: "Uključuju sav novac i kapitalna ulaganja koji ide gradskim proračunskim korisnicima, a to su sport (sufinanciranje sportskih događanja i korištenje sportskih objekata), vrtići i osnovne škole (srednje su pod nadležnosti županije), kultura (muzeji, kazališta, knjižnice, glazba, zaštita spomenika kulture), itd.",
    },
    {
        id: 32,
        word: "Transparentnost proračuna",	
        description: "Kada građani (javnost) imaju potpuni uvid u sve transakcije koje su provedene kroz proračun. Transparentnost se često miješa sa otvorenošću proračuna, no one nisu iste. Otvorenost podrazumijeva da građani vide sve stavke proračuna i koji je gradski ured odnosno proračunski korisnik koliko dobio sredstava. Transparentnost proračuna je korak dalje; ono omogućuje direktan uvid u sve transakcije koje je grad proveo - od pojedinačnih računa do toga koje su sve firme dobile poslove preko gradskih javnih natječaja.",
    }
];

export interface GlossaryItem {
    id: number;
    word: string;
    description: string;
    links?: string[];
    relatedLinks?: Link[];
    relatedStories?: Link[];
}

export interface Link {
    text: string;
    link: string;
}


// WEBPACK FOOTER //
// ./src/glossary/GlossaryService.ts